
import { UpdateCurrentUserEmailScreenNavigationProps } from "./types"
import React from "react"
import UpdateCurrentUserEmail from "./update-current-user-email-screen"
import { PageRoot } from "~screens/page-root"


const UpateContactScreen: React.FC<UpdateCurrentUserEmailScreenNavigationProps> = () => {
  return (
    <PageRoot>
      <UpdateCurrentUserEmail />
    </PageRoot>
  )
}

export default UpateContactScreen
